module.exports = __webpack_public_path__ + "static/media/footerHoneywellLogo.48294a18.svg";